.root {
  align-items: center;
  color: var(--color-muted-foreground);
  cursor: help;
  display: inline-flex;
  font-size: 12px;
  gap: 4px;
  // Marks the figure as carrying an explanation, matching the planner's
  // existing "On request" affordance.
  text-decoration: underline dotted;
  text-underline-offset: 2px;
}

// Set apart from the catalog price beside it: this is historical cost, not the
// product's own rate, and the two must never read as the same number.
.amount {
  font-weight: 500;
}

.bubble {
  max-width: 280px;
}
